/**
 * Font-pairing options offered in the My Agency picker. `value` is the key
 * persisted to `agency.fontPairing`; client-v2 resolves it to the heading + body
 * families. The set mirrors the client-v2 font registry's selectable, vendored
 * pairings — a client-v2 test enforces that the keys stay aligned.
 */
export const FONT_PAIRING_OPTIONS = [
  { value: '00', label: 'Outfit + Inter' },
  { value: '01', label: 'Athelas + Atyp Display' },
  { value: '02', label: 'Crimson Pro + Inter' },
  { value: '03', label: 'Cormorant Garamond + Montserrat' },
  { value: '04', label: 'DM Serif Display + Manrope' },
  { value: '05', label: 'Lora + Work Sans' },
  { value: '06', label: 'Spectral + Karla' },
  { value: '07', label: 'Rector + Figtree' },
  { value: '08', label: 'New Spirit + Circular Pro' },
  { value: '09', label: 'Chivo + Public Sans' },
  { value: '10', label: 'Libre Baskerville + Libre Franklin' },
];

export const FONT_PAIRING_KEYS = FONT_PAIRING_OPTIONS.map(option => option.value);
